import { type FC, useRef, ViewTransition } from 'react';

import { Outlet, ScrollRestoration, useLocation, useNavigation } from 'react-router-dom';

import { AnalyticsConsent } from '@features/analytics';
import { AppHeader } from '@widgets/app-header/AppHeader';
import { CatalogDropdown } from '@widgets/catalog-dropdown/CatalogDropdown';

import { useRouteFocus } from './lib/useRouteFocus';
import styles from './MainLayout.module.css';
import { RouteProgress } from './RouteProgress';
import { SiteFooter } from './SiteFooter';

export const MainLayout: FC = () => {
  const mainRef = useRef<HTMLElement>(null);
  // Фокус после перехода — здесь, а не в страницах: каждой странице достаточно своего h1
  useRouteFocus(mainRef);
  const loading = useNavigation().state === 'loading';
  const { pathname } = useLocation();

  return (
    <div className={styles.root}>
      <RouteProgress />
      <AppHeader />
      <CatalogDropdown />

      <main className={styles.pageContent} ref={mainRef} aria-busy={loading || undefined}>
        {/* Переход между страницами — короткий кросс-фейд содержимого (стили — global.css).
            Ключ — адрес: анимируется только смена страницы (старая уходит, новая входит). update
            не анимируем — иначе страница вспыхивала второй раз, когда внутри неё раскрывался
            Suspense (догрузка карты, фото). Гидратацию React не анимирует */}
        <ViewTransition key={pathname} default="none" enter="rpso-page" exit="rpso-page">
          <Outlet />
        </ViewTransition>
      </main>

      <SiteFooter />
      {/* Уведомление cookie и Метрика — на всех страницах; изменить решение — в политике, раздел про cookie */}
      <AnalyticsConsent />
      {/* Новый переход — страница сверху (ссылки подвала, логотип); «назад» — к прежнему месту */}
      <ScrollRestoration />
    </div>
  );
};
